import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)); }, []);
  useEffect(() => {
    document.title = "Rehber — kolaysatis.com";
    return () => { document.title = "kolaysatis.com"; };
  }, []);
  return (
    <div className="max-w-[900px] mx-auto px-6 py-16" data-testid="blog-page">
      <p className="text-[11px] uppercase tracking-[0.28em] font-medium text-slate-400 mb-3">Rehber</p>
      <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tight text-slate-900">
        Güvenli alışverişin rehberi
      </h1>
      <p className="text-slate-500 mt-3 leading-relaxed">Deneyimli editörlerimizden pratik ipuçları.</p>

      <div className="mt-12 space-y-8">
        {posts.map((p) => (
          <Link key={p.id} to={`/rehber/${p.slug}`} data-testid={`blog-item-${p.slug}`}
                className="block group">
            <article className="py-6 border-b divider">
              <h2 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-slate-900 group-hover:text-[#B54037] transition-colors">
                {p.title}
              </h2>
              <p className="text-slate-600 mt-3 leading-relaxed">{p.excerpt}</p>
              <p className="text-xs text-slate-400 mt-3">{p.author} · {new Date(p.created_at).toLocaleDateString("tr-TR")}</p>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(({ data }) => setPost(data)); }, [slug]);
  useEffect(() => {
    if (post?.seo_title) document.title = post.seo_title;
    return () => { document.title = "kolaysatis.com"; };
  }, [post?.seo_title]);
  if (!post) return <div className="max-w-[720px] mx-auto px-6 py-24 text-slate-400">Yükleniyor…</div>;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "description": post.seo_description || post.excerpt,
    "author": { "@type": "Person", "name": post.author },
    "datePublished": post.created_at,
    "dateModified": post.updated_at,
  };

  return (
    <article className="max-w-[720px] mx-auto px-6 py-16" data-testid="blog-post">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <p className="text-[11px] uppercase tracking-[0.28em] font-medium text-slate-400 mb-3">
        <Link to="/rehber" className="hover:text-slate-900">Rehber</Link>
      </p>
      <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tight text-slate-900 leading-tight">
        {post.title}
      </h1>
      <p className="text-xs text-slate-400 mt-3 font-mono-tight">
        {post.author} · {new Date(post.created_at).toLocaleDateString("tr-TR")}
      </p>
      <div className="prose prose-slate max-w-none mt-10 text-slate-800 leading-[1.8]"
           style={{ whiteSpace: "pre-wrap" }}
           dangerouslySetInnerHTML={{
             __html: post.body
               .replace(/\*\*(.+?)\*\*/g, '<strong class="text-slate-900">$1</strong>')
               .replace(/\n\n/g, "<br/><br/>")
           }} />
    </article>
  );
}
